import { Grid, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';

export const StatisticsIncomeListPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <GridWrapper>
        <Grid item xs={12} md={4}>
          <MainContentHeader title={t('statistics:payments.sideTitle')} />
        </Grid>
        <Grid item xs={12} sx={{ mb: 0 }} />
      </GridWrapper>
      <GridWrapper>
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>StatisticsIncomeListPage</Paper>
        </Grid>
      </GridWrapper>
    </>
  );
};
